import urlJoin from "url-join";
import pageConfig from '@/config/errorPageConfig.json';

// url origin
const origin = window.location.origin;
const path = pageConfig.path;

export const toErrorPage = (errorType) => {
  let url;
  switch (errorType) {
    case 'timeout':
      url = urlJoin(origin, path, pageConfig.timeoutErrorFile);
      break;

    case '403':
      url = urlJoin(origin, path, pageConfig.forbiddenErrorFile);
      break;

    case '500':
      url = urlJoin(origin, path, pageConfig.internalServerErrorFile);
      break;

    default:
      break;
  }

  if (url) {
    return window.location.replace(url);
  }
};